"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BleReaderCount = 0;

var BleReader = function () {
  function BleReader(device) {
    _classCallCheck(this, BleReader);

    BleReaderCount += 1;
    this.readerName = "R-" + BleReaderCount;
    this.device = device;
    this.device_uuid = device.device_uuid;
    this.service_uuid = device.service_uuid;
    this.measurement_uuids = device.measurement_uuids;
    this.alt_service = device.alternateService();
    this.name = device.name;
    this.serial = device.serial;

    this.stopped = false;
    this.stopping = false;

    this.id_from_device = null;
  }

  _createClass(BleReader, [{
    key: "onConnect",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onConnect(_x) {
        return _ref.apply(this, arguments);
      }

      return onConnect;
    }()
  }, {
    key: "onFinish",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(readings) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onFinish(_x2) {
        return _ref2.apply(this, arguments);
      }

      return onFinish;
    }()
  }, {
    key: "onStartNotification",
    value: function onStartNotification(measurement_uuid) {
      //override
    }
  }, {
    key: "stop",
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log(this.readerName + " Stopping:");

                if (!this.stopping) {
                  _context3.next = 5;
                  break;
                }

                console.log(this.readerName + " Already stopped");
                _context3.next = 38;
                break;

              case 5:
                this.stopping = true;
                _context3.prev = 6;

                this.stopReadingTimeout();
                this.stopScanTimeout();
                _context3.prev = 9;
                _context3.next = 12;
                return this.stopScan(20 * 1000);

              case 12:
                _context3.next = 16;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](9);

              case 16:
                _context3.prev = 16;
                _context3.next = 19;
                return this.unsubscribe(20 * 1000);

              case 19:
                _context3.next = 23;
                break;

              case 21:
                _context3.prev = 21;
                _context3.t1 = _context3["catch"](16);

              case 23:
                _context3.prev = 23;
                _context3.next = 26;
                return this.disconnect(20 * 1000);

              case 26:
                _context3.next = 30;
                break;

              case 28:
                _context3.prev = 28;
                _context3.t2 = _context3["catch"](23);

              case 30:
                this.stopped = true;
                _context3.next = 38;
                break;

              case 33:
                _context3.prev = 33;
                _context3.t3 = _context3["catch"](6);

                this.stopped = true;
                console.error(this.readerName + " Stop exception:");
                console.error(_context3.t3);

              case 38:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 33], [9, 14], [16, 21], [23, 28]]);
      }));

      function stop() {
        return _ref3.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "waitForReadings",
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(connectParams, progress) {
        var result, scanWaitTime, scanResult;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:

                console.log(this.readerName + " Connecting to " + this.name + ": " + this.device_uuid);
                result = {};
                scanWaitTime = mymobileConfig.readings_timeout_seconds * 1000;

                if ("scanWaitTime" in connectParams) {
                  scanWaitTime = connectParams.scanWaitTime;
                }

                // try to connect directly first

                if (!this.device.needsInitialConnect()) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 7;
                return this.getReadingsWithTimeout(connectParams, progress);

              case 7:
                result = _context4.sent;
                _context4.next = 11;
                break;

              case 10:
                result = { ok: false, reader: this.readerName };

              case 11:
                if (result.ok) {
                  _context4.next = 23;
                  break;
                }

                _context4.next = 14;
                return this.scanForDeviceWithTimeout(scanWaitTime);

              case 14:
                scanResult = _context4.sent;

                if (!scanResult.found) {
                  _context4.next = 23;
                  break;
                }

                _context4.next = 18;
                return this.stopScan(null);

              case 18:
                _context4.next = 20;
                return this.getReadingsWithRetry(connectParams, progress, 15);

              case 20:
                result = _context4.sent;

                console.log(this.readerName + " result from getReadingsWithRetry");
                console.log(result);

              case 23:
                if (!result.ok) {
                  _context4.next = 29;
                  break;
                }

                console.log("BLE Reader: waitForReadings returning.");
                console.log(result);
                return _context4.abrupt("return", result.readings);

              case 29:
                console.error(this.readerName + " throwing: ");
                console.error(result);
                throw result;

              case 32:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function waitForReadings(_x3, _x4) {
        return _ref4.apply(this, arguments);
      }

      return waitForReadings;
    }()
  }, {
    key: "checkSerialNumber",
    value: function checkSerialNumber(serial) {

      var normalizeId = function normalizeId(str) {
        if (typeof str != 'string') {
          return "";
        } else {
          return str.replace(/\s+/g, '').replace(/\-/g, '').toLowerCase();
        }
      };

      console.log("Device Serial: " + serial + " " + normalizeId(serial));
      console.log("Expected Serial:  " + this.serial + " " + normalizeId(this.serial));

      var serialOK = normalizeId(this.serial) == normalizeId(serial);

      if (!serialOK) {
        this.device.addToIgnoreList(this.id_from_device);
      }

      return serialOK;
    }
  }, {
    key: "scanForDeviceWithTimeout",
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(scanWaitTime) {
        var _this = this;

        var scanPromise, timeoutPromise, result;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                scanPromise = this.scanForDevice();
                timeoutPromise = new Promise(function (resolve, reject) {
                  _this.stopScanTimeout();
                  var waitTime = scanWaitTime;
                  console.log(_this.readerName + " start scan timer for: " + waitTime);
                  _this.scanTimeout = setTimeout(function () {
                    _this.scanTimeout = null;
                    _this.callbackSuccess('timeout', "scan timer timeout", reject, reject); // reject either wat
                  }, waitTime);
                });
                _context5.next = 4;
                return Promise.race([timeoutPromise, scanPromise]);

              case 4:
                result = _context5.sent;
                return _context5.abrupt("return", result);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function scanForDeviceWithTimeout(_x5) {
        return _ref5.apply(this, arguments);
      }

      return scanForDeviceWithTimeout;
    }()
  }, {
    key: "stopScanTimeout",
    value: function stopScanTimeout() {
      if (this.scanTimeout) {
        console.log(this.readerName + " clear scan timer");

        clearTimeout(this.scanTimeout);
        this.scanTimeout = null;
      }
    }
  }, {
    key: "scanForDevice",
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", new Promise(function (resolve, reject) {

                  var found = false;

                  console.log(_this2.readerName + " scan for: " + _this2.device_uuid + " " + _this2.device.getAdvertisedName());

                  ble.startScan([], function (unknown_device) {
                    console.log(_this2.readerName + " scan result: " + unknown_device.id + " " + unknown_device.name);

                    if (!_this2.callbackSuccess(unknown_device, "ble.startScan", null, reject)) {
                      return;
                    }

                    if (!found) {
                      if (BLE_CONTROL.identifyDevicesBySerialNumber()) {

                        if (unknown_device.name == _this2.device.getAdvertisedName() && !_this2.device.ignoreDevice(unknown_device.id)) {
                          _this2.id_from_device = unknown_device.id;
                          _this2.device_uuid = unknown_device.id;
                          found = true;
                          resolve({ ok: true, found: true });
                        }
                      } else {
                        if (unknown_device.id == _this2.device_uuid) {
                          found = true;
                          resolve({ ok: true, found: true });
                        }
                      }
                    }
                  }, function (error) {
                    _this2.callbackError(error, "ble.startScan", resolve, reject);
                  });
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function scanForDevice() {
        return _ref6.apply(this, arguments);
      }

      return scanForDevice;
    }()
  }, {
    key: "stopScan",
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(timeout) {
        var _this3 = this;

        var scanPromise;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                scanPromise = new Promise(function (resolve, reject) {

                  console.log(_this3.readerName + " ble.stopScan...");

                  ble.stopScan(function (result) {
                    _this3.callbackSuccess(result, "ble.stopScan", resolve, reject);
                  }, function (error) {
                    _this3.callbackError(error, "ble.stopScan", resolve, reject);
                  });
                });

                if (!(timeout == null)) {
                  _context7.next = 5;
                  break;
                }

                return _context7.abrupt("return", scanPromise);

              case 5:
                return _context7.abrupt("return", Promise.race([scanPromise, this.sleep(timeout)]));

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function stopScan(_x6) {
        return _ref7.apply(this, arguments);
      }

      return stopScan;
    }()
  }, {
    key: "sleep",
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(waitTime) {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", new Promise(function (resolve, reject) {
                  console.log(_this4.readerName + " start sleep timer for: " + waitTime);
                  setTimeout(function () {
                    _this4.callbackSuccess('timeout', "sleep done", resolve, reject);
                  }, waitTime);
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function sleep(_x7) {
        return _ref8.apply(this, arguments);
      }

      return sleep;
    }()
  }, {
    key: "getReadingsWithRetry",
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(connectParams, progress, numTries) {
        var result;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!true) {
                  _context9.next = 22;
                  break;
                }

                _context9.next = 3;
                return this.getReadingsWithTimeout(connectParams, progress);

              case 3:
                result = _context9.sent;

                if (!result.ok) {
                  _context9.next = 8;
                  break;
                }

                return _context9.abrupt("return", result);

              case 8:
                console.error(this.readerName + ' connect error:');console.error(result);

                if (!(result.error && result.error.errorCode == "GATT_ERROR")) {
                  _context9.next = 16;
                  break;
                }

                console.log(this.readerName + ' try again...' + numTries);
                _context9.next = 14;
                return this.sleep(500);

              case 14:
                _context9.next = 17;
                break;

              case 16:
                return _context9.abrupt("return", result);

              case 17:

                numTries -= 1;

                if (!(numTries <= 0)) {
                  _context9.next = 20;
                  break;
                }

                return _context9.abrupt("return", result);

              case 20:
                _context9.next = 0;
                break;

              case 22:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getReadingsWithRetry(_x8, _x9, _x10) {
        return _ref9.apply(this, arguments);
      }

      return getReadingsWithRetry;
    }()
  }, {
    key: "getReadingsWithTimeout",
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(connectParams, progress) {
        var _this5 = this;

        var readingsPromise, timeoutPromise, result;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                readingsPromise = this.getReadings(connectParams, progress);
                timeoutPromise = new Promise(function (resolve, reject) {

                  var waitTime = _this5.device.readingWaitTime();

                  _this5.stopReadingTimeout();
                  console.log(_this5.readerName + " start reading timer for: " + waitTime);

                  _this5.readingTimeout = setTimeout(function () {
                    _this5.readingTimeout = null;
                    _this5.callbackSuccess('timeout', "reading timer timeout", reject, reject); // reject either way!
                  }, waitTime);
                });
                _context10.next = 4;
                return Promise.race([timeoutPromise, readingsPromise]);

              case 4:
                result = _context10.sent;
                return _context10.abrupt("return", result);

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getReadingsWithTimeout(_x11, _x12) {
        return _ref10.apply(this, arguments);
      }

      return getReadingsWithTimeout;
    }()
  }, {
    key: "stopReadingTimeout",
    value: function stopReadingTimeout() {
      if (this.readingTimeout) {
        console.log(this.readerName + " clear reading timer");

        clearTimeout(this.readingTimeout);
        this.readingTimeout = null;
      }
    }
  }, {
    key: "getReadings",
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(connectParams, progress) {
        var _this6 = this;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", new Promise(function () {
                  var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(resolve, reject) {
                    var readings, disconnected, self, alive, connectedResult, result, _readings;

                    return regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            readings = null;
                            disconnected = false;
                            self = _this6;

                            alive = function alive() {
                              if (disconnected) {
                                console.log(self.readerName + " alive check - disconnected");
                              };
                              return !disconnected;
                            };

                            _context11.prev = 4;
                            _context11.next = 7;
                            return _this6.connect(function (disconnectResult) {
                              // Unexpected disconnect from the device while we're still communicating with it
                              console.log(_this6.readerName + " Unexpected Disconnect sent from device");

                              // set disconnected so we give up on further communication        
                              disconnected = true;

                              // to prevent connection retries. 

                              if (readings != null) {
                                resolve({ ok: true, readings: readings, reader: _this6.readerName });
                              } else {
                                resolve({ ok: false, disconnected: true, reader: _this6.readerName });
                              }
                            });

                          case 7:
                            connectedResult = _context11.sent;

                            if (connectedResult.ok) {
                              _context11.next = 12;
                              break;
                            }

                            resolve(connectedResult);
                            _context11.next = 41;
                            break;

                          case 12:
                            if (!alive()) {
                              _context11.next = 15;
                              break;
                            }

                            _context11.next = 15;
                            return _this6.onConnect(connectParams);

                          case 15:
                            result = null;

                            if (!alive()) {
                              _context11.next = 20;
                              break;
                            }

                            _context11.next = 19;
                            return _this6.subscribe(progress, reject);

                          case 19:
                            result = _context11.sent;

                          case 20:
                            console.log(_this6.readerName + " getReadings result");
                            console.log(result);

                            if (!(result && result.ok && !!result.readings)) {
                              _context11.next = 41;
                              break;
                            }

                            _readings = result.readings;

                            if (!_readings.progress) {
                              _context11.next = 28;
                              break;
                            }

                            if (alive()) {
                              progress(_readings.progress);
                            }
                            _context11.next = 41;
                            break;

                          case 28:
                            if (!alive()) {
                              _context11.next = 31;
                              break;
                            }

                            _context11.next = 31;
                            return _this6.onFinish(_readings);

                          case 31:
                            if (!alive()) {
                              _context11.next = 34;
                              break;
                            }

                            _context11.next = 34;
                            return _this6.preprocessReading(_readings);

                          case 34:
                            if (!alive()) {
                              _context11.next = 37;
                              break;
                            }

                            _context11.next = 37;
                            return _this6.unsubscribe(null);

                          case 37:
                            if (!alive()) {
                              _context11.next = 40;
                              break;
                            }

                            _context11.next = 40;
                            return _this6.disconnect(null);

                          case 40:
                            if (alive()) {
                              resolve({ ok: true, readings: _readings, reader: _this6.readerName });
                            }

                          case 41:
                            _context11.next = 48;
                            break;

                          case 43:
                            _context11.prev = 43;
                            _context11.t0 = _context11["catch"](4);

                            console.error(_this6.readerName + " getReadings exception:");
                            console.error(_context11.t0);
                            reject(_context11.t0);

                          case 48:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11, _this6, [[4, 43]]);
                  }));

                  return function (_x15, _x16) {
                    return _ref12.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getReadings(_x13, _x14) {
        return _ref11.apply(this, arguments);
      }

      return getReadings;
    }()
  }, {
    key: "checkAlternateService",
    value: function checkAlternateService(connectResult) {

      if (this.alt_service) {
        //  if the alt service is advertised, switch to it

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = connectResult.services[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var uuid = _step.value;

            if (this.alt_service.service_uuid.toUpperCase() == uuid.toUpperCase()) {
              this.service_uuid = this.alt_service.service_uuid;
              this.measurement_uuids = this.alt_service.measurement_uuids;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }, {
    key: "connect",
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(disconnected) {
        var _this7 = this;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", new Promise(function (resolve, reject) {

                  console.log(_this7.readerName + " ble.connect...");

                  var connected = false;

                  try {
                    ble.connect(_this7.device_uuid, function (result) {
                      connected = true;
                      _this7.checkAlternateService(result);
                      _this7.callbackSuccess(result, "ble.connect", resolve, reject);
                    }, function (error) {
                      _this7.callbackError(error, "ble.connect", function (result) {
                        if (connected) {
                          result.disconnected = true;
                          disconnected(result);
                        } else {
                          resolve(result);
                        }
                      }, reject);
                    });
                  } catch (e) {
                    _this7.callbackError(e, "ble.connect", resolve, reject);
                  }
                }));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function connect(_x17) {
        return _ref13.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(timeout) {
        var _this8 = this;

        var prms;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                prms = new Promise(function (resolve, reject) {

                  console.log(_this8.readerName + " ble.disconnect...");

                  ble.disconnect(_this8.device_uuid, function (result) {
                    _this8.callbackSuccess(result, "ble.disconnect", resolve, reject);
                  }, function (error) {
                    _this8.callbackError(error, "ble.disconnect", resolve, reject);
                  });
                });

                if (!(timeout == null)) {
                  _context14.next = 5;
                  break;
                }

                return _context14.abrupt("return", prms);

              case 5:
                return _context14.abrupt("return", Promise.race([prms, this.sleep(timeout)]));

              case 6:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function disconnect(_x18) {
        return _ref14.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "readingChecksum",
    value: function readingChecksum(reading, date) {
      var checksum = "";
      if (reading.date) {
        date = reading.date;
      }
      checksum += "" + date.valueOf();

      $.each(reading.measurements, function (index, measurement) {
        checksum += measurement.name + measurement.value;
        if (measurement.designations) {
          checksum += measurement.designations.join("");
        }
      });

      reading.checksum = pidCrypt.SHA1(checksum);
    }
  }, {
    key: "preprocessReading",
    value: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(readingContainer) {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, reading;

        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(this.device.preventDuplicates && readingContainer.readings.length > 0)) {
                  _context15.next = 28;
                  break;
                }

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context15.prev = 4;
                _iterator2 = readingContainer.readings[Symbol.iterator]();

              case 6:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context15.next = 14;
                  break;
                }

                reading = _step2.value;

                this.readingChecksum(reading, readingContainer.date);
                _context15.next = 11;
                return this.checkDuplicateReading(reading);

              case 11:
                _iteratorNormalCompletion2 = true;
                _context15.next = 6;
                break;

              case 14:
                _context15.next = 20;
                break;

              case 16:
                _context15.prev = 16;
                _context15.t0 = _context15["catch"](4);
                _didIteratorError2 = true;
                _iteratorError2 = _context15.t0;

              case 20:
                _context15.prev = 20;
                _context15.prev = 21;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 23:
                _context15.prev = 23;

                if (!_didIteratorError2) {
                  _context15.next = 26;
                  break;
                }

                throw _iteratorError2;

              case 26:
                return _context15.finish(23);

              case 27:
                return _context15.finish(20);

              case 28:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[4, 16, 20, 28], [21,, 23, 27]]);
      }));

      function preprocessReading(_x19) {
        return _ref15.apply(this, arguments);
      }

      return preprocessReading;
    }()
  }, {
    key: "checkDuplicateReading",
    value: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(reading) {
        var _this9 = this;

        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", new Promise(function (resolve, reject) {

                  BLE_CONTROL.lookupReading(_this9.device.device_uuid, reading.checksum, function (result) {
                    reading.duplicate = result == "FOUND";
                    console.log("check duplicate: " + reading.duplicate + " " + _this9.device_uuid + " " + reading.checksum);
                    resolve("OK");
                  }, function (error) {
                    console.error("Could not lookup reading");
                    console.error(error);
                    resolve("OK");
                  });
                }));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function checkDuplicateReading(_x20) {
        return _ref16.apply(this, arguments);
      }

      return checkDuplicateReading;
    }()
  }, {
    key: "subscribe",
    value: function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(progress, onStopped) {
        var prms, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, measurement_uuid;

        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                console.log(this.readerName + " subscribing: " + this.measurement_uuids.join(","));

                prms = [];
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context17.prev = 5;

                for (_iterator3 = this.measurement_uuids[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  measurement_uuid = _step3.value;

                  prms.push(this.startNotification(measurement_uuid, onStopped, progress));
                }

                _context17.next = 13;
                break;

              case 9:
                _context17.prev = 9;
                _context17.t0 = _context17["catch"](5);
                _didIteratorError3 = true;
                _iteratorError3 = _context17.t0;

              case 13:
                _context17.prev = 13;
                _context17.prev = 14;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 16:
                _context17.prev = 16;

                if (!_didIteratorError3) {
                  _context17.next = 19;
                  break;
                }

                throw _iteratorError3;

              case 19:
                return _context17.finish(16);

              case 20:
                return _context17.finish(13);

              case 21:
                return _context17.abrupt("return", Promise.race(prms));

              case 22:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[5, 9, 13, 21], [14,, 16, 20]]);
      }));

      function subscribe(_x21, _x22) {
        return _ref17.apply(this, arguments);
      }

      return subscribe;
    }()
  }, {
    key: "unsubscribe",
    value: function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(timeout) {
        var prms, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, measurement_uuid, allPromise;

        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                console.log(this.readerName + " unsubscribing:" + this.measurement_uuids.join(","));

                prms = [];
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context18.prev = 5;

                for (_iterator4 = this.measurement_uuids[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  measurement_uuid = _step4.value;

                  prms.push(this.stopNotification(measurement_uuid));
                }

                _context18.next = 13;
                break;

              case 9:
                _context18.prev = 9;
                _context18.t0 = _context18["catch"](5);
                _didIteratorError4 = true;
                _iteratorError4 = _context18.t0;

              case 13:
                _context18.prev = 13;
                _context18.prev = 14;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 16:
                _context18.prev = 16;

                if (!_didIteratorError4) {
                  _context18.next = 19;
                  break;
                }

                throw _iteratorError4;

              case 19:
                return _context18.finish(16);

              case 20:
                return _context18.finish(13);

              case 21:
                allPromise = Promise.all(prms);

                if (!(timeout == null)) {
                  _context18.next = 26;
                  break;
                }

                return _context18.abrupt("return", allPromise);

              case 26:
                return _context18.abrupt("return", Promise.race([allPromise, this.sleep(timeout)]));

              case 27:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[5, 9, 13, 21], [14,, 16, 20]]);
      }));

      function unsubscribe(_x23) {
        return _ref18.apply(this, arguments);
      }

      return unsubscribe;
    }()
  }, {
    key: "handleResult",
    value: function handleResult(result) {

      var reading = this.device._decode_result(result, this);

      if (reading && reading.valid) {
        this.readingCount += 1;

        if (!this.device.skipReading(reading, this.readingCount)) {
          reading.batteryStatus = this.batteryStatus;
          this.successCallback({ ok: true, readings: reading });
        }
      }
    }
  }, {
    key: "startNotification",
    value: function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(measurement_uuid, onStopped, progress) {
        var _this10 = this;

        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", new Promise(function (resolve, reject) {

                  _this10.readingCount = 0;
                  var name = "ble.startNotification (" + _this10.service_uuid + " " + measurement_uuid + ")";

                  console.log(_this10.readerName + " " + name);

                  _this10.successCallback = resolve;
                  _this10.failureCallback = reject;
                  _this10.progressCallback = progress;

                  _this10.onStartNotification(measurement_uuid);

                  ble.startNotification(_this10.device_uuid, _this10.service_uuid, measurement_uuid, function (result) {

                    if (_this10.callbackSuccess(result, name, null, onStopped)) {
                      _this10.handleResult(result);
                    }
                  }, function (error) {
                    _this10.callbackError(error, name, resolve, onStopped);
                  }, _this10.device.returnsFloatValue);
                }));

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function startNotification(_x24, _x25, _x26) {
        return _ref19.apply(this, arguments);
      }

      return startNotification;
    }()
  }, {
    key: "stopNotification",
    value: function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(measurement_uuid) {
        var _this11 = this;

        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", new Promise(function (resolve, reject) {

                  var name = "ble.stopNotification (" + _this11.service_uuid + " " + measurement_uuid + ")";

                  console.log(_this11.readerName + " " + name);

                  ble.stopNotification(_this11.device_uuid, _this11.service_uuid, measurement_uuid, function (result) {
                    _this11.callbackSuccess(result, name, resolve, reject);
                  }, function (error) {
                    _this11.callbackError(error, name, resolve, reject);
                  });
                }));

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function stopNotification(_x27) {
        return _ref20.apply(this, arguments);
      }

      return stopNotification;
    }()
  }, {
    key: "getBatteryStatus",
    value: function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var result, battery_byte_array;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:

                this.batteryStatus = null;

                _context21.next = 3;
                return this.read("180F", "2A19");

              case 3:
                result = _context21.sent;


                if (result.ok) {
                  battery_byte_array = new Uint8Array(result.result);

                  this.batteryStatus = battery_byte_array[0];
                  console.log(this.batteryStatus);
                }

              case 5:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function getBatteryStatus() {
        return _ref21.apply(this, arguments);
      }

      return getBatteryStatus;
    }()
  }, {
    key: "read",
    value: function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(service_uuid, characteristic_uuid) {
        var _this12 = this;

        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", new Promise(function (resolve, reject) {

                  var name = "ble.read " + service_uuid + " " + characteristic_uuid;
                  console.log(_this12.readerName + " " + name);

                  ble.read(_this12.device_uuid, service_uuid, characteristic_uuid, function (result) {
                    _this12.callbackSuccess(result, name, resolve, reject);
                  }, function (error) {
                    _this12.callbackError(error, name, resolve, reject);
                  });
                }));

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function read(_x28, _x29) {
        return _ref22.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "write",
    value: function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(service_uuid, characteristic_uuid, buffer) {
        var _this13 = this;

        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", new Promise(function (resolve, reject) {

                  var name = "ble.write " + service_uuid + " " + characteristic_uuid;
                  console.log(_this13.readerName + " " + name);

                  ble.write(_this13.device_uuid, service_uuid, characteristic_uuid, buffer, function (result) {
                    _this13.callbackSuccess(result, name, resolve, reject);
                  }, function (error) {
                    _this13.callbackError(error, name, resolve, reject);
                  });
                }));

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function write(_x30, _x31, _x32) {
        return _ref23.apply(this, arguments);
      }

      return write;
    }()
  }, {
    key: "writeWithoutResponse",
    value: function () {
      var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(service_uuid, characteristic_uuid, buffer) {
        var _this14 = this;

        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt("return", new Promise(function (resolve, reject) {

                  var name = "ble.writeWithoutResponse " + service_uuid + " " + characteristic_uuid;
                  console.log(_this14.readerName + " " + name);

                  ble.writeWithoutResponse(_this14.device_uuid, service_uuid, characteristic_uuid, buffer, function (result) {
                    _this14.callbackSuccess(result, name, resolve, reject);
                  }, function (error) {
                    _this14.callbackError(error, name, resolve, reject);
                  });
                }));

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function writeWithoutResponse(_x33, _x34, _x35) {
        return _ref24.apply(this, arguments);
      }

      return writeWithoutResponse;
    }()
  }, {
    key: "callbackError",
    value: function callbackError(error, name, resolve, reject) {
      console.error(this.readerName + " callback failed: " + name);
      console.error(error);

      var result = { ok: false, stopped: false, reader: this.readerName, error: error, callback: name };
      if (this.stopped) {
        result.stopped = true;
        console.log(this.readerName + " Stopped - rejecting.. ");
        reject(result);
      } else {
        resolve(result);
      }
    }
  }, {
    key: "callbackSuccess",
    value: function callbackSuccess(result, name, resolve, reject) {
      console.log(this.readerName + " callback ok: " + name);

      if (this.stopped) {
        console.log(this.readerName + " Stopped - rejecting.. ");
        reject({ ok: false, stopped: true, reader: this.readerName, callback: name });
        return false;
      } else {
        if (resolve) {
          resolve({ ok: true, result: result, stopped: false, reader: this.readerName, callback: name });
        }
        return true;
      }
    }
  }]);

  return BleReader;
}();